import MomentUtils from "@date-io/moment";
import dayjs from "dayjs";


function hslToHex(hsl) {
  let {h, s, l} = hsl
  h /= 360;
  s /= 100;
  l /= 100;
  let r; let g; let b;
  if (s === 0) {
  r = g = b = l; // achromatic
  } else {
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  r = hue2rgb(p, q, h + 1 / 3);
  g = hue2rgb(p, q, h);
  b = hue2rgb(p, q, h - 1 / 3);
  }
  const toHex = x => {
  const hex = Math.round(x * 255).toString(16);
  return hex.length === 1 ? `0${  hex}` : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
 

}

const customColor = (seriesData, diff =16) => {
  const colors = []
  for (let i=0; i< seriesData.length; i++){
  const hsl = {h:i*diff, s: 100, l:80}
  const result = seriesData[i] === 0 ? 'transparent' : hslToHex(hsl)
  colors.push(result)
  }
  return colors
}

export default customColor;

export const ucFirst = (str) => {
  if (typeof (str) !== 'string') {
    return ''
  }

  if (!str?.trim()) {
    return ''
  }

  return str.split(' ').map((item) => `${item.charAt(0).toUpperCase()}${item.slice(1).toLowerCase()}`).join(' ')
}

export const ucFirstLetter = (str) => {
  if (typeof (str) !== 'string') {
    return ''
  }

  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const stripHtml = (html) =>{
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export const acceptFileType = ['.doc', '.docx', '.pdf', '.txt', '.xls', '.xlsx', '.csv', '.ppt', '.pptx', '.jpg', '.jpeg', '.png', ".plain", ".msword", ".vnd.openxmlformats-officedocument.wordprocessingml.document",
".vnd.oasis.opendocument.text"]

export const titleCase = (s) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ` ${  d.toUpperCase()}`)


export const formatDateForContract =(date) =>{
    const moment = (new MomentUtils()).date(date).format('YYYY-MM-DD');
	return moment
}

export const formatDate =(date) =>{
  const moment = (new MomentUtils()).date(date).format('MM-DD-YYYY');
return moment
}

export const getLastDayOfMonth = (year, month) =>{
  const date = new Date(year, month + 1, 0);

  return date.getDate();
}

export const getMonth = (month) =>{
  const monthFormatted = (month + 1).toString().padStart(2, '0');

  return monthFormatted;
}

export const checkForIdInFilter = (filterData) => {
  const updatedData = {};  // Create a new object to store the updated data

  for (const key in filterData) {
    const filterValue = filterData[key].filter;
    
    // Check if the filter contains "id:"
    if (filterValue?.includes("id:")) {
      const [leftPart, ...rightParts] = filterValue.split('_');
      // Store the part before the first underscore in a separate variable
      const removedLeft = leftPart;
      // The rest of the string after the first underscore
      const remainingString = rightParts.join('_')
      
      // Store the updated object in the new variable
      updatedData[key] = {
        ...filterData[key],  // Copy the rest of the data
        filter: remainingString,  // Updated filter value
        id: removedLeft.replace("id:", "")
      };
    } else {
      // If "id:78_" is not present, just copy the original filter data
      updatedData[key] = filterData[key];
    }
  }

return updatedData;
}

export const convertProperDateFormat = (date) => {
  const [year, month, day] = date?.toString().split('-');
  const formatDates = `${month}/${day}/${year}`;
  return formatDates
}

const userRegion = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const convertToTimezone = (utcString, type = 'date') => {
  const utcDate = type === 'date' || process.env.REACT_APP_BACKEND_API_URL?.includes('localhost')  ? new Date(utcString) : new Date(`${utcString  } UTC`);
  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: userRegion,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(utcDate);

  return date.replace('at', ' : ')
}

export const formatToMMMDDYYYY = (inputDate) => {
  if (!inputDate) return "";

  const date = new Date(inputDate);

  return date.toLocaleDateString("en-US", {
    timeZone: userRegion,   // prevents Dec 31 / Jan 1 issue
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const handleFilterApplied = (filterJson, gridRef, isClient = false) => {
    console.log('filterJson', filterJson, gridRef)
    if (!gridRef) {
      return
    }
  
    if (filterJson?.filterModel && Object.keys(filterJson?.filterModel)?.length) {
      const resolved = resolveAgGridFilterModel(filterJson?.filterModel);
      console.log('resolvedFilterModel00', resolved, gridRef)
      gridRef.setFilterModel(resolved);
      gridRef.onFilterChanged();
  }

    if (filterJson?.sortModel?.length) {
      gridRef?.applyColumnState({
        defaultState: { sort: null },
        state: filterJson.sortModel
      });
    }
    if (filterJson?.columnState?.length) {
      gridRef.applyColumnState({
        state: filterJson.columnState,
        applyOrder: true
      });
    }
    if (filterJson?.quickFilter) {
      gridRef.setGridOption("quickFilterText", filterJson.quickFilter);
    }
  
    if (typeof gridRef?.refreshServerSide === 'function' && !isClient) {
      gridRef?.refreshServerSide({ purge: true });
    } else {
      gridRef?.refreshCells({ force: true });
    }
}

const resolveRelativeDate = (value) => {
  if (!value) return null;

  if (!String(value).startsWith("RELATIVE_")) {
    return new Date(value);
  } 

  const relativeDates = ContractDateMapping(value);
  return relativeDates || null;
};

function ContractDateMapping(dateFilter) {
  const now = new Date();

  const startOfDay = (d) => {
    const date = new Date(d);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const endOfDay = (d) => {
    const date = new Date(d);
    date.setHours(23, 59, 59, 999);
    return date;
  };

  const today = startOfDay(now);

 const todayPlus90 = startOfDay(new Date(now));
  todayPlus90.setDate(todayPlus90.getDate() + 90);

  // ---- Month ----
  const thisMonthStart = startOfDay(new Date(now.getFullYear(), now.getMonth(), 1));
  const thisMonthEnd = endOfDay(new Date(now.getFullYear(), now.getMonth() + 1, 0));

  const lastMonthStart = startOfDay(new Date(now.getFullYear(), now.getMonth() - 1, 1));
  const lastMonthEnd = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));

  // ---- Quarter ----
  const quarter = Math.floor(now.getMonth() / 3);
  const thisQuarterStart = startOfDay(new Date(now.getFullYear(), quarter * 3, 1));
  const thisQuarterEnd = endOfDay(new Date(now.getFullYear(), quarter * 3 + 3, 0));
const thisYearStart = startOfDay(new Date(now.getFullYear(), 0, 1));
const thisYearEnd = endOfDay(new Date(now.getFullYear(), 11, 31));

  // ---- last Year ----
  const lastYearStart = startOfDay(new Date(now.getFullYear() - 1, 0, 1));
  const lastYearEnd = endOfDay(new Date(now.getFullYear() - 1, 11, 31));
  switch (dateFilter) {
    case 'RELATIVE_TODAY':
      return today;
    case 'RELATIVE_TODAY_PLUS_90':
      return todayPlus90;
    case 'RELATIVE_THIS_MONTH_START':
      return thisMonthStart;
    case 'RELATIVE_THIS_MONTH_END':
      return thisMonthEnd;
    case 'RELATIVE_THIS_QUARTER_START':
      return thisQuarterStart;
    case 'RELATIVE_THIS_QUARTER_END':
      return thisQuarterEnd;
    case 'RELATIVE_LAST_MONTH_START':
      return lastMonthStart;
    case 'RELATIVE_LAST_MONTH_END':
      return lastMonthEnd;
    case 'RELATIVE_THIS_YEAR_START':
      return thisYearStart;
    case 'RELATIVE_THIS_YEAR_END':
      return thisYearEnd;
    case 'RELATIVE_LAST_YEAR_START':
      return lastYearStart;
    case 'RELATIVE_LAST_YEAR_END':
      return lastYearEnd
    default:
      return dateFilter;
  }

  // return {
  //   RELATIVE_TODAY: today,
  //   RELATIVE_TODAY_PLUS_90: todayPlus90,
  //   RELATIVE_THIS_MONTH_START: thisMonthStart,
  //   RELATIVE_THIS_MONTH_END: thisMonthEnd,
  //   RELATIVE_LAST_MONTH_START: lastMonthStart,
  //   RELATIVE_LAST_MONTH_END: lastMonthEnd,
  //   RELATIVE_THIS_QUARTER_START: thisQuarterStart,
  //   RELATIVE_THIS_QUARTER_END: thisQuarterEnd,
  //   RELATIVE_THIS_YEAR_START: thisYearStart,
  //   RELATIVE_THIS_YEAR_END: thisYearEnd,
  //   RELATIVE_LAST_YEAR_START: lastYearStart,
  //   RELATIVE_LAST_YEAR_END: lastYearEnd,
  // };
}
  
export function clientSideApplyFilterModel(rows, filterModel) {
  if (!filterModel || Object.keys(filterModel).length === 0) {
    return rows;
  }

  return rows.filter((row) => {
    return Object.entries(filterModel).every(([field, condition]) => {
      const value = row[field];
      if (value === undefined || value === null) return false;

      // 🔹 TEXT FILTER
      if (condition.filterType === "text") {
        const rowValue = String(value).toLowerCase();
        const filterValue = String(condition.filter).toLowerCase();

        switch (condition.type) {
          case "equals":
            return rowValue === filterValue;
          case "contains":
            return rowValue.includes(filterValue);
          case "startsWith":
            return rowValue.startsWith(filterValue);
          case "endsWith":
            return rowValue.endsWith(filterValue);
          default:
            return true;
        }
      }

      // 🔹 DATE FILTER
      if (condition.filterType === "date") {
        const rowDate = new Date(value);

        if (condition.type === "inRange") {
          const from =
            resolveRelativeDate(condition.dateFrom) ||
            new Date(condition.dateFrom);

          const to =
            resolveRelativeDate(condition.dateTo) ||
            new Date(condition.dateTo);

          return rowDate >= from && rowDate <= to;
        }

        if (condition.type === "equals") {
          const target = new Date(condition.dateFrom);
          return rowDate.toDateString() === target.toDateString();
        }
      }

      return true;
    });
  });
}

export function calculateTimeDifference(createdAt) {
  const createdDate = new Date(createdAt);
  const now = new Date();

  const diffMs = now - createdDate;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) {
    return "just now";
  }

  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
  }

  if (diffDays === 1) {
    return "yesterday";
  }

  return `${diffDays} days ago`;
}

export function getContractStatus(endDate) {
  const today = dayjs().startOf("day");
  const end = dayjs(endDate).startOf("day");

  if (!end.isValid()) return "unknown";

  const diffDays = end.diff(today, "day");

  if (diffDays < 0) return "expired";
  if (diffDays <= 90) return "expiring";
  return "active";
}
export function getMonthWiseContractCount(data) {
  const map = {};

  data.forEach(({ name }) => {
    if (!name) return;

    const d = dayjs(name);
    if (!d.isValid()) return;

    const monthKey = d.format("YYYY-MM"); // stable key

    if (!map[monthKey]) {
      map[monthKey] = {
        name: d.startOf("month").valueOf(),
        label: name,
        value: 0
      };
    }

    map[monthKey].value += 1;
  });

  return Object.values(map).sort((a, b) => a.name - b.name);
}

export const STATUS_COLORS = {
  expired: "#dc3545",
  active: "#28a745",
  expiring: '#d69e2e',
  
};

export function resolveAgGridFilterModel(filterModel) {
  if (!filterModel) return filterModel;

  const cloned = filterModel;

  Object.entries(cloned).forEach(([col, filter]) => {
    if (filter.filterType === "date") {
      const fromRange = ContractDateMapping(filter.dateFrom);
      const toRange = ContractDateMapping(filter.dateTo);

      if (fromRange) {
        cloned[col].dateFrom = dayjs(fromRange).format("YYYY-MM-DD");
      }

      if (toRange) {
        cloned[col].dateTo = dayjs(toRange).format("YYYY-MM-DD");
      }
    }
  });

  return cloned;
}

 export const getPercentWidth = (w, n, x) => {
    const percentWidth = Math.round((x / (w / n)) * 100)
    return `${percentWidth}%`
  }





